import { createTheme, responsiveFontSizes } from "@material-ui/core"
import { grey, deepOrange } from "@material-ui/core/colors"

const theme = responsiveFontSizes(
  createTheme({
    // palette: {
    //   type: 'dark',
    // },
    palette: {
      primary: deepOrange,
      secondary: grey,
    },
  })
)

export default theme
